/* eslint-disable arrow-body-style */

export const removeIndex = (primaryDataArray, excludeDataParamsArray) => {
    return primaryDataArray.map((el => Object.fromEntries(Object.entries(el).filter(([k]) => !excludeDataParamsArray.includes(k)))));
};
